import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

const animationBlockquoteEffect = (container) => {
  if (container.querySelectorAll('blockquote')) {
    let blockquote = container.querySelectorAll('blockquote');

    [].forEach.call(blockquote, function (element) {
      let paragraph = element.querySelectorAll('p');

      for (let i = 0; i < paragraph.length; i++) {
        if (paragraph[i].querySelector('p > cite')) {
          let cite = paragraph[i].querySelectorAll('cite');

          gsap.set(cite, {autoAlpha:0, y:+60})

          const anim = gsap.to(cite, {
            duration: 0.5,
            delay: 1.5,
            y: 0,
            autoAlpha: 1,
            ease: 'power3.out',
          });

          ScrollTrigger.create({
            trigger: paragraph[i],
            onEnter: () => anim.restart(true),
          });
        } else {
          let split = new SplitText(paragraph[i], { type: 'words' });

          gsap.set(split.words, {autoAlpha:0, y:+30})

          const anim = gsap.to(split.words, {
            duration: 1,
            delay: 1,
            stagger: 0.015,
            y: 0,
            autoAlpha: 1,
            ease: 'power3.out',
          });

          ScrollTrigger.create({
            trigger: paragraph[i],
            onEnter: () => anim.restart(true),
          });
        }
      }
    });
  }
};

export default animationBlockquoteEffect;
